import { useState } from 'react'
import useCopyToClipboard from '../Hook/CopyToClipboard'
import TreeNode from './TreeNode'
import { highlightJson } from 'Helper/DatalogHelper'

export default function JsonViewerPanel ({ data, title = 'Response' }) {
  const [jsonTab, setJsonTab] = useState('tree') /* "tree" | "raw" */
  const [copiedJson, copyJson] = useCopyToClipboard()

  const rawJson = data != null ? JSON.stringify(data, null, 2) : null

  return (
    <div className="dv-card dv-json-panel">
      <div className="dv-card-header">
        <span className="dv-card-title">
          <i className="fa fa-code" /> {title}
        </span>
        <div className="dv-json-toolbar">
          <button
            className={`dv-json-tab${jsonTab === 'tree' ? ' active' : ''}`}
            onClick={() => setJsonTab('tree')}
          >
            tree
          </button>
          <button
            className={`dv-json-tab${jsonTab === 'raw' ? ' active' : ''}`}
            onClick={() => setJsonTab('raw')}
          >
            raw
          </button>
          {rawJson && (
            <button
              className={`dv-copy-small${copiedJson ? ' copied' : ''}`}
              onClick={() => copyJson(rawJson)}
            >
              <i className={`fa fa-${copiedJson ? 'check' : 'copy'}`} />
              {copiedJson ? 'Copied' : 'Copy JSON'}
            </button>
          )}
        </div>
      </div>

      {jsonTab === 'tree' && (
        data != null
          ? (
          <div className="dv-json-tree">
            <TreeNode nodeKey={null} value={data} depth={0} />
          </div>
            )
          : (
          <div className="dv-json-empty">no response data</div>
            )
      )}

      {jsonTab === 'raw' && (
        rawJson
          ? (
          <pre
            className="dv-json-raw"
            dangerouslySetInnerHTML={{ __html: highlightJson(rawJson) }}
          />
            )
          : (
          <div className="dv-json-empty">no response data</div>
            )
      )}
    </div>
  )
}